var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('email-verification',{attrs:{"header":_vm.$t("profile.kyc.level1Text"),"title":_vm.$t('kycUserIdentity.details')}})}
var staticRenderFns = []

export { render, staticRenderFns }